export const environment = {
  production: false,
  enablePfeuCreditApplicationReport: true,
  azureAd: {
    clientId: '19d5f830-8835-40c3-aae6-fe29b5175a6a',
    authority: 'https://login.microsoftonline.com/6e93a626-8aca-4dc1-9191-ce291b4b75a1',
    redirectUrl: 'https://ccubedev03.rabo.cloud',
    posLogoutUrl: 'https://ccubedev03.rabo.cloud',
  },
  scopes: ['GroupMember.Read.All','User.Read'],
  // removed allowedGroupIds; use adminGroupId and connectorGroupMap instead
  // Admin group id (users in this group see all applications)
  adminGroupId: '21516683-25ac-4203-b3cf-0924ee44238c',
  // Map connector keys to the Azure AD group IDs that should see them
  connectorGroupMap: {
    AG_DESK: ['c1041074-7df1-40af-afc3-220ef7675f2e'],
    PFEU: ['d3110242-2cab-4db7-80d6-eebd2256333e'],
    VCF: ['d86c4b87-ac4b-4a43-b7f0-94bd62f69489']
  },
  
  apiBaseUrl: 'https://ccubedev03.rabo.cloud/api/v1',
  resourceBatches: function() {
    return `api://${this.azureAd.clientId}/batches`;
  }
};
